import { observable } from "@legendapp/state";
import type * as Ably from "ably";
import { toast } from "sonner";

import { getOrgChannel } from "~/libs/pubsub.lib";
import { trpc } from "~/libs/trpc.lib";
import { syncedCrudPersist } from "../../libs/legend-state";
import { orgReady$ } from "../app-data-ready";
import type { Connection } from "./connections.types";

export const connections$ = observable(
  syncedCrudPersist<Connection>({
    persist: {
      name: "connections",
    },
    waitFor: orgReady$,
    list: async () => {
      return await trpc.connections.list.query();
    },
    delete: async (input) => {
      if (!input.id) return;

      await trpc.connections.delete.mutate({
        connectionId: input.id,
      });

      toast.success("Connection deleted successfully");
    },
    subscribe: ({ update }) => {
      const channel = getOrgChannel();
      if (!channel) return;

      const handler = (message: Ably.Message) => {
        update({
          mode: "merge",
          value: Array.isArray(message.data) ? message.data : [message.data],
        });
      };

      channel.subscribe("connections", handler);

      return () => {
        channel.unsubscribe("connections", handler);
      };
    },
  }),
);
